import { RichTextEditorConfigFeatureEnum } from '../enum/rich-text-editor-config-feature.enum';

export class RichTextEditorConfigModel {

    // These strings correspond to the toolbar items in ckeditor.ts
    public static FEATURE_MAP: Map<RichTextEditorConfigFeatureEnum, string[]> = new Map([
        [RichTextEditorConfigFeatureEnum.enablePersonalizations, ['agprPersonalizations']],
        [RichTextEditorConfigFeatureEnum.enableLineHeight, ['lineHeight']],
        [RichTextEditorConfigFeatureEnum.enableHeading, ['heading']],
        [RichTextEditorConfigFeatureEnum.enableFontColor, ['agprFontColor']],
        [RichTextEditorConfigFeatureEnum.enableBackgroundColor, ['agprFontBackgroundColor']],
        [RichTextEditorConfigFeatureEnum.enableHtmlEditor, ['sourceEditing']],
        [RichTextEditorConfigFeatureEnum.enableAIRefinement, ['agprPrCoPilot']],
        [RichTextEditorConfigFeatureEnum.enableFontFamily, ['fontFamily']],
        [RichTextEditorConfigFeatureEnum.enableFontSize, ['fontSize']],
        [RichTextEditorConfigFeatureEnum.enableInsertImage, ['imageUpload']],
        [RichTextEditorConfigFeatureEnum.enableStrikethrough, ['strikethrough']],
        [RichTextEditorConfigFeatureEnum.enableAlignment, ['alignment']],
        [RichTextEditorConfigFeatureEnum.enableNumberedList, ['numberedList']],
        [RichTextEditorConfigFeatureEnum.enableBlockQuote, ['blockQuote']],
        [RichTextEditorConfigFeatureEnum.enableTranslation, ['agprTranslationDropdown', 'agprTranslationButton']]
    ]);

    enablePersonalizations: boolean = false;
    enableLineHeight: boolean = true;
    enableHeading: boolean = true;
    enableFontColor: boolean = true;
    enableBackgroundColor: boolean = true;
    enableHtmlEditor: boolean = true;
    enableAIHelper: boolean = false;
    enableAIRefinement: boolean = false;
    enableFontFamily: boolean = true;
    enableFontSize: boolean = true;
    enableInsertImage: boolean = true;
    enableStrikethrough: boolean = true;
    enableAlignment: boolean = true;
    enableNumberedList: boolean = true;
    enableBlockQuote: boolean = true;
    enableDirection: boolean = true;
    enableIndent: boolean = true;
    enableTranslation: boolean = false;
    hideInsert: boolean = false;
    aiReferenceId: string = '';
    pastePlainText: boolean = false;

    constructor(
        args: {
            editHTML?: boolean;
            enablePersonalizations?: boolean;
            enableLineHeight?: boolean;
            enableHeading?: boolean;
            enableFontColor?: boolean;
            enableBackgroundColor?: boolean;
            enableHtmlEditor?: boolean;
            enableAIHelper?: boolean;
            enableAIRefinement?: boolean;
            enableFontFamily?: boolean;
            enableFontSize?: boolean;
            enableInsertImage?: boolean;
            enableAlignment?: boolean;
            enableStrikethrough?: boolean;
            enableNumberedList?: boolean;
            enableBlockQuote?: boolean;
            enableDirection?: boolean;
            enableIndent?: boolean;
            enableTranslation?: boolean;
            pastePlainText?: boolean;
            hideInsert?: boolean;
            aiReferenceId: string;
        }
    ) {
        for (const property of Object.keys(args)) {
            this[property] = args[property];
        }
    }
}
